export const faqData = [
    {
      q: "Was ist AI Videoproduktion?",
      a: "AI Videoproduktion nutzt künstliche Intelligenz (KI), um innovative Videoclips zu erstellen. mAIsblau in Wien kombiniert modernste KI-Tools mit professioneller Filmproduktion, um schnelle, kreative und kosteneffiziente Videos für Social Media, Werbung und Marketing zu produzieren."
    },
    {
      q: "Sehen KI-Videos unnatürlich oder „robotisch“ aus?",
      a: "Nein – wenn ein Filmemacher am Werk ist. Andreas Hofmarcher kommt aus klassischer Kamera-, Schnitt- und Color-Arbeit und veredelt jedes KI-Video mit Human-in-the-loop-Feinschliff. So wird der typische KI-Look vermieden. Hybrid-Produktionen (echter Dreh + KI-Erweiterung) liefern oft die natürlichste Wirkung."
    },
    {
      q: "Was kostet eine AI Videoproduktion in Wien?",
      a: "Transparent und planbar: Ein KI-Reel (15–20 Sekunden, inkl. Schnitt, Color Grading & Sound) kostet ab 900 € netto, eine KI-Kampagne mit mehreren Szenen ab 2.200 € netto. Klassische Produktionen wie Imagefilme oder Dokumentationen werden individuell kalkuliert. Das Erstgespräch ist kostenlos!"
    },
    {
      q: "Wie viel kostet eine KI-Videoproduktion im Vergleich zum klassischen Dreh?",
      a: "Deutlich günstiger und planbarer – besonders bei Varianten und Social-Clips, weil Location, Crew, Casting und Drehtage entfallen. Echte Drehs bleiben sinnvoll, wenn Authentizität (Mitarbeiter, Standort, Produkt in der Hand) im Mittelpunkt steht. mAIsblau kalkuliert transparent und kombiniert beides."
    },
    {
      q: "Wie schnell geht eine KI-Videoproduktion?",
      a: "Erste Ergebnisse liefert mAIsblau häufig in wenigen Werktagen. Klassische Produktionen dauern oft 4–8 Wochen, KI-gestützte meist nur Tage bis 1–2 Wochen. Bei Hybrid-Projekten wird der reale Dreh effizient geplant und generativ erweitert – ideal für schnelle Kampagnen."
    },
    {
      q: "Kann man echten Dreh und KI kombinieren (Hybrid)?",
      a: "Ja – und oft ist das die beste Lösung. Andreas dreht echte Menschen, Produkte und Locations in Wien und erweitert generativ: Set-Extensions, Hintergründe, zusätzliche Formate. Authentizität plus das Unmögliche in einem Film."
    },
    {
      q: "Was ist der Unterschied zwischen Voll-KI und Hybrid?",
      a: "Voll-KI: kein Dreh nötig, maximal schnell und flexibel. Hybrid: echte Aufnahmen plus generative Erweiterung – mehr Authentizität und oft die stärkste Lösung."
    },
    {
      q: "Kann mein echtes Produkt realistisch und konsistent vorkommen?",
      a: "Ja. mAIsblau arbeitet mit echten Produktfotos oder kurzen Drehs und hält Form, Farbe, Logo und Material konsistent über alle Szenen. Bei Bedarf wird das Produkt real gedreht und die Welt mit KI ergänzt."
    },
    {
      q: "Kann man Kamerabewegungen und Stil präzise steuern?",
      a: "Ja. Mit Referenzbildern und -videos sowie gezielter Steuerung entsteht filmische Kameraführung – besonders wichtig für konsistente Kampagnen."
    },
    {
      q: "Ist die Qualität gut genug für Marken und Werbung?",
      a: "Ja – wenn Idee, Bildsprache, Licht, Schnitt und Farbe von einem Filmemacher kommen. Reine Prompt-Generierung reicht selten für Markenqualität."
    },
    {
      q: "Welche Videos eignen sich besonders für KI?",
      a: "Produktreels, Social-Clips (Reels/Shorts), Werbespots, Konzept-Visualisierungen, Musikvideos und Erklärfilme. Weniger ideal, wenn echte Mitarbeiter, echte Emotionen vor Ort oder der Standort selbst die Story sind."
    },
    {
      q: "Eignet sich KI auch für erzählende Filme oder Musikvideos?",
      a: "Ja. Generierte Welten plus handwerklicher Schnitt, Pacing und Sounddesign funktionieren sehr gut für narrative Formate – hör und sieh dir zum Beispiel das Musikvideo „Notfallsong“ an."
    },
    {
      q: "Eignet sich das für Social Media (Reels, TikTok, LinkedIn)?",
      a: "Sehr gut. mAIsblau liefert direkt die richtigen Formate (9:16, 1:1, 16:9) und Cutdowns für alle Kanäle."
    },
    {
      q: "Wann ist klassische Produktion besser als KI?",
      a: "Wenn echte Menschen, echte Emotionen, der reale Standort oder ein physisches Produkt im Mittelpunkt stehen sollen. Andreas berät ehrlich und mischt beides, wo es Sinn macht."
    },
    {
      q: "Wie läuft eine KI-Videoproduktion ab?",
      a: "Briefing → Konzept/Storyboard → Look-Entwicklung → Umsetzung (KI oder Hybrid) → Postproduktion mit Schnitt, Color und Sound (DaVinci o. Ä.) → fertige Formate für alle Kanäle. Erste Ergebnisse siehst du oft schon nach wenigen Werktagen."
    },
    {
      q: "Was passiert, wenn der erste Entwurf nicht passt?",
      a: "mAIsblau arbeitet iterativ mit Korrekturschleifen. Änderungen gehen bei KI deutlich schneller und günstiger als Nachdrehs."
    },
    {
      q: "Brauche ich ein fertiges Skript?",
      a: "Nein. Konzept und Text entstehen gemeinsam aus deinem Briefing."
    },
    {
      q: "Welche Tools werden verwendet?",
      a: "Aktuelle KI-Modelle der neuesten Generation plus klassische Postproduktion. Entscheidend ist nicht das Tool, sondern die filmische Regie und der Feinschliff."
    },
    {
      q: "Wer besitzt die Rechte am fertigen Video?",
      a: "Mit Abnahme und Bezahlung räumt mAIsblau dir die Nutzungsrechte zeitlich und räumlich unbegrenzt ein – inklusive TV-Nutzung. Das Urheberrecht selbst ist in Österreich nicht übertragbar (§ 23 UrhG); der genaue Umfang steht transparent im Angebot."
    },
    {
      q: "Müssen KI-Videos gemäß EU AI Act gekennzeichnet werden?",
      a: "Ja – seit 2. August 2026 besonders relevant bei Deepfakes oder täuschend echten Inhalten. mAIsblau kennzeichnet transparent nach Artikel 50 – sichtbar mit „Mit KI generiert“ links oben im Bild – und berät dich, wann genau die Pflicht greift und wie man sie stilvoll umsetzt, ohne den Film zu stören."
    },
    {
      q: "Ist KI-Videoproduktion DSGVO-konform?",
      a: "mAIsblau achtet auf EU-konforme Prozesse (DSGVO) und vermeidet unnötige personenbezogene Daten. Bei Avataren oder Stimmen wird die Rechtsgrundlage im Vorfeld geklärt – pauschale Zusagen ersetzt eine saubere Prüfung pro Projekt."
    },
    {
      q: "Gibt es lokale KI-Video-Anbieter in Wien?",
      a: "Ja. Als Wiener Produktion kennt mAIsblau den Markt, die Locations und die Erwartungen österreichischer Kunden – vor Ort oder remote."
    },
    {
      q: "Welche Regionen rund um Wien bedient mAIsblau?",
      a: "mAIsblau bedient Wien und einen Umkreis von 100 km. Das umfasst ganz Niederösterreich (St. Pölten, Wiener Neustadt, Baden, Mödling, Krems, Klosterneuburg, Tulln), das nördliche Burgenland (Eisenstadt, Neusiedl am See) sowie Bratislava."
    },
    {
      q: "Warum AI Videos für mein Unternehmen in Wien?",
      a: "AI Videos bieten entscheidende Vorteile: schnellere Produktionszeiten, geringere Kosten als traditionelle Drehs, unbegrenzte kreative Möglichkeiten und die Fähigkeit, einzigartige visuelle Welten zu erschaffen. Ideal für Social Media Marketing, Werbung und Markenaufbau in Wien."
    },
    {
      q: "Bietet mAIsblau auch klassische Videoproduktion an?",
      a: "Ja! Neben AI Videoproduktion bietet mAIsblau klassische Filmproduktion: Interviews, Videoportraits, TV-Produktionen, Dokumentationen, Imagefilme und Event-Dokumentation. Der journalistische Zugang macht jede Produktion besonders authentisch."
    }
];
